import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { checkToken } from "./guards/checkToken";
import { checkLogin } from "./guards/checkLogin";
import { checkMaintenance } from "./guards/checkMaintenance";
import { startRedirect } from "./guards/startRedirect";
import { NoindexMarker } from "./guards/markNoindex";
import { removeHash } from "./guards/removeHash";
import multiguard from "vue-router-multiguard";
import { applications, qrApplications } from "./application";
import { auth } from "./auth";
import { maintenance } from "./maintenance";
import { message } from "./message";
import { mypage, cameraMypage } from "./mypage";
import { orders } from "./orders";
import { register, cameraRegister } from "./register";
import { top } from "./top";
import { versions } from "./versions";
import { redirects } from "./redirects";
import { firstBoot } from "./firstBoot";
import { ad } from "./ad";
import { training } from "./training";
import { notFound } from "@/router/notFound";
import { completedCancelRequest } from "./guards/completedCancelRequest";
import { VUE_APP_ENV } from "@/config/VueAppEnv";
import { setProduct } from "./guards/setProduct";

const routes: Array<RouteRecordRaw> = [
  top,
  applications,
  qrApplications,
  auth,
  register,
  cameraRegister,
  orders,
  maintenance,
  message,
  mypage,
  cameraMypage,
  versions,
  redirects,
  firstBoot,
  ad,
  training,
  notFound
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { left: 0, top: 0 };
    }
  }
});

router.beforeEach(
  multiguard([
    removeHash,
    NoindexMarker.produceMarker(VUE_APP_ENV),
    setProduct,
    checkToken,
    checkLogin,
    checkMaintenance,
    startRedirect,
    completedCancelRequest
  ])
);

export default router;
